<template>
  <div class="product-name-with-thumbnail">
    <img v-if="product.thumb.length > 0" :src="product.thumb[0].currentMedia.url" />
    <img v-else class="no-thumbnail" :src="require('@/assets/images/image-placeholder-grayscale.webp')" />
    <span class="product-name">{{ product.product_name }}</span>
  </div>
</template>

<script>
export default {
  name: "ProductNameWithThumbnail",
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="less">
.product-name-with-thumbnail {
  display: inline-flex;

  img {
    max-width: 42px !important;
    width: 100%;
    height: 100%;
    border-radius: 3px;
  }

  .product-name {
    margin-top: auto !important;
    margin-bottom: auto !important;
    margin-left: 15px !important;
    white-space: nowrap;
  }

}
</style>
